import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'return-from-client',
  templateUrl: './templates/return-from-client.component.html',
  styleUrls: ['./styles/return-from-client.component.css']
})
export class ReturnFromClientComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/return-from-client.component.ts